import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { ProductMockup } from './ui/ProductMockup';
import { StarIcon } from 'lucide-react';
export function Hero() {
  const {
    hero
  } = pageData;
  const scrollToOffer = () => {
    const cta = document.getElementById('offer-cta');
    const target = cta || document.getElementById('offer-card');
    if (!target) return;
    // Align the pay button's BOTTOM to the bottom of the viewport so the
    // button AND the price above it are both in view on mobile.
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });
    // Re-align a couple of times to absorb any layout shift from lazy images
    // loading after the scroll begins (otherwise the target lands off-screen).
    const realign = () => target.scrollIntoView({
      behavior: 'auto',
      block: 'end'
    });
    setTimeout(realign, 450);
    setTimeout(realign, 900);
  };
  return <section className="relative px-4 overflow-hidden md:pt-5 md:pb-16 min-h-[100svh] md:min-h-0 flex items-center md:block pt-[5px] pb-[5px]" data-id="element-85">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-gold-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-86" />

      <div className="max-w-6xl mx-auto relative z-10 flex flex-col items-center text-center w-full" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-88">
          <Badge className="mb-3 md:mb-6" data-id="element-89">{hero.badge}</Badge>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-4xl sm:text-6xl md:text-8xl lg:text-9xl max-w-5xl mx-auto leading-[0.95] md:leading-[0.9] mb-3 md:mb-6" data-id="element-90">
          {hero.headline.part1}
          <span className="text-gold-500 block mt-1 md:mt-2" data-id="element-91">
            {hero.headline.highlight}
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-sm sm:text-lg md:text-xl text-slate-300 max-w-2xl mx-auto mb-4 md:mb-8 text-balance" data-id="element-92">
          {hero.subheadline}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.3
      }} className="w-full" data-id="element-93">
          <ProductMockup data-id="element-94" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="w-full mt-4 md:mt-8" data-id="element-95">
          <Button onClick={scrollToOffer} data-id="element-96">{hero.ctaText}</Button>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-2 mt-3 md:mt-4" data-id="element-97">
            <div className="flex text-gold-500 shrink-0" data-id="element-98">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-99" />)}
            </div>
            <span className="text-xs sm:text-sm text-slate-400 font-medium text-center text-balance px-2" data-id="element-100">
              {hero.ratingText}
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}